import React, { useState } from 'react';

import CPageModuleTableBase, { type IPageModuleTableBaseProps } from '../CPageModuleTableBase';
import { updateStateAttribute } from '../helpers/helper';
import { type IBrowsableTableInternalState } from '../models/IBrowsableTableInternalState';
import CBrowsableTable, { type IBrowsableTableProps } from '../pages/playground/CBrowsableTable';

type Props = Omit<IBrowsableTableProps, 'onUpdateInternalState'> & Pick<IPageModuleTableBaseProps, 'style'>;

interface State {
  internalState?: IBrowsableTableInternalState;
}

export default function CPageModuleBrowsableTable(props: Props) {
  const [state, setState] = useState<State>({});

  return (
    <CPageModuleTableBase
      state={props.state}
      data={props.data}
      table={
        <div className={'flex flex-col gap-4'}>
          <CBrowsableTable
            {...props}
            onUpdateInternalState={(internalState) => {
              updateStateAttribute<State>({ internalState }, setState);
            }}
          />
        </div>
      }
      pagination={state.internalState?.paginator}
      timestamp={state.internalState?.timestamp()}
      searchBar={props.searchBar !== false ? state.internalState?.searchBar : undefined}
      style={props.style}
    />
  );
}
